import { ExpandMore } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownToggle, Label, UncontrolledDropdown } from "reactstrap";
import { ISelectOption } from "../../forms/util";
import '../OperationalForms.css'
import { operationalFormsRoute, trainEventAdminOverviewPathRoute, trainEventRecordOverviewPathRoute, trainEventRecordPathRoute, trainEventRecordSectionPathRoute, trainEventUsersSubmittedFormListRoute } from "../OperationalFormsRoutes";

const getOperationalFormsRoute = () => { return operationalFormsRoute; }
const getTrainEventRecordSectionRoute = () => { return trainEventRecordSectionPathRoute; }
const getTrainEventRecordOverviewRoute = () => { return trainEventRecordOverviewPathRoute }
const getTrainEventRecordRoute = () => { return trainEventRecordPathRoute; }
const getUserTrainEventRecordRoute = () => { return trainEventUsersSubmittedFormListRoute; }
const getAdminTrainEventRecordRoute = () => { return trainEventAdminOverviewPathRoute; }

export const operationalFormsHomePage = {
    label: "Operational Forms",
    value: "operationalFormsHomePage",
    getRoute: getOperationalFormsRoute
} as ISelectOption;

export const trainEventRecordSection = {
    label: "Train Event Record Section",
    value: "trainEventRecordSection",
    getRoute: getTrainEventRecordSectionRoute
} as ISelectOption;

export const trainEventRecord = {
    label: "Train Event Record",
    value: "trainEventRecord",
    getRoute: getTrainEventRecordRoute,
    subitem: true
} as ISelectOption;

export const trainEventRecordOverview = {
    label: "Train Event Record Overview",
    value: "trainEventRecordOverview",
    getRoute: getTrainEventRecordOverviewRoute,
    subitem: true
} as ISelectOption;

export const trainEventUsersSubmittedFormList = {
    label: "My Train Event Records",
    value: "trainEventUsersSubmittedFormList",
    getRoute: getUserTrainEventRecordRoute
} as ISelectOption;

export const trainEventAdminSummaryDashboardOverview = {
    label: "Train Event Dashboard",
    value: "trainEventAdminSummaryDashboardOverview",
    getRoute: getAdminTrainEventRecordRoute,
} as ISelectOption;

interface TrainEventRecordPageSelectorProps {
    selectedPage: ISelectOption
}

export const TrainEventRecordPageSelector = (props: TrainEventRecordPageSelectorProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const [selectOptions, setSelectOptions] = useState([props.selectedPage] as ISelectOption[]);
    const navigate = useNavigate();

    const getSelectOptions = () => {
        var options: ISelectOption[] = [];
        options.push(operationalFormsHomePage);
        options.push(trainEventRecordSection);
        options.push(trainEventRecordOverview);
        options.push(trainEventRecord);

        return options;
    }

    const selectOnChange = (selectOption: ISelectOption) => {
        var path = selectOption.getRoute().path;
        if (selectOption !== currentSelection && typeof (path) === 'string') {
            navigate(path);
        }
    }

    useEffect(() => {
        if (currentSelection === undefined) {
            setCurrentSelection(operationalFormsHomePage);
        }

        if (selectOptions.length <= 1) {
            setSelectOptions(getSelectOptions());
        }
    }, [selectOptions]);

    return (
        <div className="rail-operations-selector-selector fa-narrow">
            <UncontrolledDropdown>
                <DropdownToggle tag="div" className="rbt-input-main form-control rbt-input">
                    <div className="te-select-options">{currentSelection.label}</div>
                </DropdownToggle>
                <ExpandMore />
                <DropdownMenu className="te-page-selector">
                    {selectOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`form-check-inline dropdown-item ${option.value}${option.subitem ? ' sub-item' : ''}`}
                            onClick={() => selectOnChange(option)}>
                            <Label className={`form-check-label`}>{option.label}</Label>
                        </div>

                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
};